import { render, staticRenderFns } from "./CreateEditQuiz.vue?vue&type=template&id=36672365"
import script from "./CreateEditQuiz.vue?vue&type=script&lang=js"
export * from "./CreateEditQuiz.vue?vue&type=script&lang=js"
import style0 from "./CreateEditQuiz.vue?vue&type=style&index=0&id=36672365&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports